// (function () {
//   function initSlider(root) {
//     var track = root.querySelector('[data-slider-track]');
//     var viewport = root.querySelector('[data-slider-viewport]');
//     var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slider-slide]'));
//     var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slider-dot]'));
//     var prevBtn = root.querySelector('[data-slider-prev]');
//     var nextBtn = root.querySelector('[data-slider-next]');

//     if (!track || !slides.length) return;

//     var slidesDesktop = parseInt(root.getAttribute('data-slides-desktop'), 10) || 3;
//     var slidesTablet = parseInt(root.getAttribute('data-slides-tablet'), 10) || 2;
//     var slidesMobile = 1;
//     var autoplay = root.getAttribute('data-autoplay') === 'true';
//     var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;

//     var total = slides.length;
//     var index = 0;
//     var perView = slidesDesktop;
//     var autoplayTimer = null;

//     function getPerView() {
//       var w = window.innerWidth;
//       if (w <= 749) return slidesMobile;
//       if (w <= 989) return Math.min(slidesTablet, total);
//       return Math.min(slidesDesktop, total);
//     }

//     function maxIndex() {
//       return Math.max(0, total - perView);
//     }

//     function update() {
//       index = Math.min(index, maxIndex());
//       index = Math.max(index, 0);

//       var slideWidthPercent = 100 / perView;
//       var gapPx = 24;
//       var offset = index * (slideWidthPercent);
//       // account for gaps: shift by index * (100% + gap) / perView using px correction
//       track.style.transform = 'translateX(calc(-' + offset + '% - ' + (index * gapPx / perView) + 'px))';

//       dots.forEach(function (dot, i) {
//         dot.classList.toggle('is-active', i === index);
//       });

//       if (prevBtn) prevBtn.disabled = false;
//       if (nextBtn) nextBtn.disabled = false;
//     }

//     function goTo(newIndex) {
//       var max = maxIndex();
//       if (newIndex < 0) newIndex = max; // loop to end
//       if (newIndex > max) newIndex = 0; // loop to start
//       index = newIndex;
//       update();
//       resetAutoplay();
//     }

//     function next() {
//       goTo(index + 1);
//     }

//     function prev() {
//       goTo(index - 1);
//     }

//     function startAutoplay() {
//       if (!autoplay || total <= perView) return;
//       autoplayTimer = setInterval(next, autoplaySpeed);
//     }

//     function stopAutoplay() {
//       if (autoplayTimer) {
//         clearInterval(autoplayTimer);
//         autoplayTimer = null;
//       }
//     }

//     function resetAutoplay() {
//       stopAutoplay();
//       startAutoplay();
//     }

//     if (nextBtn) nextBtn.addEventListener('click', next);
//     if (prevBtn) prevBtn.addEventListener('click', prev);

//     dots.forEach(function (dot) {
//       dot.addEventListener('click', function () {
//         var i = parseInt(dot.getAttribute('data-index'), 10) || 0;
//         goTo(Math.min(i, maxIndex()));
//       });
//     });

//     // Basic touch swipe support
//     var startX = 0;
//     var isDown = false;

//     viewport.addEventListener('touchstart', function (e) {
//       startX = e.touches[0].clientX;
//       isDown = true;
//       stopAutoplay();
//     }, { passive: true });

//     viewport.addEventListener('touchend', function (e) {
//       if (!isDown) return;
//       isDown = false;
//       var endX = e.changedTouches[0].clientX;
//       var diff = startX - endX;
//       if (Math.abs(diff) > 40) {
//         if (diff > 0) {
//           next();
//         } else {
//           prev();
//         }
//       } else {
//         resetAutoplay();
//       }
//     }, { passive: true });

//     root.addEventListener('mouseenter', stopAutoplay);
//     root.addEventListener('mouseleave', startAutoplay);

//     var resizeTimer;
//     window.addEventListener('resize', function () {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(function () {
//         perView = getPerView();
//         update();
//       }, 150);
//     });

//     perView = getPerView();
//     update();
//     startAutoplay();
//   }

//   function initAll() {
//     var sliders = document.querySelectorAll('[data-reasons-slider]');
//     sliders.forEach(initSlider);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initAll);
//   } else {
//     initAll();
//   }

//   // Re-init when added/edited in the theme editor
//   document.addEventListener('shopify:section:load', function (e) {
//     var slider = e.target.querySelector('[data-reasons-slider]');
//     if (slider) initSlider(slider);
//   });
// })();


(function () {
  function initSlider(root) {
    var track = root.querySelector('[data-slider-track]');
    var viewport = root.querySelector('[data-slider-viewport]');
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-slider-slide]')
    );
    var dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-slider-dot]')
    );
    var prevBtn = root.querySelector('[data-slider-prev]');
    var nextBtn = root.querySelector('[data-slider-next]');

    if (!track || !viewport || !slides.length) return;

    var slidesDesktop =
      parseInt(root.getAttribute('data-slides-desktop'), 10) || 3;

    var slidesTablet =
      parseInt(root.getAttribute('data-slides-tablet'), 10) || 2;

    var autoplay =
      root.getAttribute('data-autoplay') === 'true';

    var autoplaySpeed =
      parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;

    var total = slides.length;
    var index = 0;
    var perView = 1;
    var autoplayTimer = null;

    /* ================================
       RESPONSIVE
    ================================= */

    function getPerView() {
      var width = window.innerWidth;

      if (width <= 749) {
        return 1;
      }

      if (width <= 989) {
        return Math.min(slidesTablet, total);
      }

      return Math.min(slidesDesktop, total);
    }

    /* ================================
       MAX POSITION

       5 cards / 3 visible:

       position 0 = 1 2 3
       position 1 = 2 3 4
       position 2 = 3 4 5

       Therefore maxIndex = 2
    ================================= */

    function getMaxIndex() {
      return Math.max(0, total - perView);
    }

    /* ================================
       UPDATE DOTS
    ================================= */

    function updateDots() {
      var maxIndex = getMaxIndex();

      dots.forEach(function (dot, i) {
        if (i <= maxIndex) {
          dot.style.display = '';
        } else {
          dot.style.display = 'none';
        }

        dot.classList.toggle(
          'is-active',
          i === index
        );
      });
    }

    /* ================================
       UPDATE SLIDER
    ================================= */

    function update() {
      perView = getPerView();

      var maxIndex = getMaxIndex();

      if (index > maxIndex) {
        index = maxIndex;
      }

      if (index < 0) {
        index = 0;
      }

      /*
        Calculate actual card width.

        Desktop:
        3 cards + 2 gaps

        Mobile:
        1 card + no gap
      */

      var gap = window.innerWidth <= 749 ? 0 : 24;

      var viewportWidth = viewport.offsetWidth;

      var slideWidth =
        (viewportWidth - ((perView - 1) * gap)) / perView;

      /*
        Move EXACTLY ONE CARD.
      */

      var offset =
        index * (slideWidth + gap);

      track.style.transform =
        'translate3d(-' + offset + 'px, 0, 0)';

      updateDots();
    }

    /* ================================
       GO TO EXACT CARD POSITION
    ================================= */

    function goTo(newIndex) {
      var maxIndex = getMaxIndex();

      /*
        Loop around.
      */

      if (newIndex < 0) {
        newIndex = maxIndex;
      }

      if (newIndex > maxIndex) {
        newIndex = 0;
      }

      /*
        IMPORTANT:
        Increment is ALWAYS 1.
      */

      index = newIndex;

      update();
      resetAutoplay();
    }

    /* ================================
       NEXT
    ================================= */

    function next() {
      goTo(index + 1);
    }

    /* ================================
       PREVIOUS
    ================================= */

    function prev() {
      goTo(index - 1);
    }

    /* ================================
       ARROWS
    ================================= */

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        next();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        prev();
      });
    }

    /* ================================
       DOTS

       Desktop:
       5 cards / 3 visible = 3 dots

       Mobile:
       5 cards / 1 visible = 5 dots
    ================================= */

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i =
          parseInt(
            dot.getAttribute('data-index'),
            10
          ) || 0;

        goTo(i);
      });
    });

    /* ================================
       DRAGGING
    ================================= */

    var startX = 0;
    var currentX = 0;
    var isDragging = false;
    var dragMoved = false;

    function startDrag(x) {
      startX = x;
      currentX = x;
      isDragging = true;
      dragMoved = false;

      stopAutoplay();

      track.style.transition = 'none';
    }

    function moveDrag(x) {
      if (!isDragging) return;

      currentX = x;

      var diff = x - startX;

      if (Math.abs(diff) > 5) {
        dragMoved = true;
      }

      var gap = window.innerWidth <= 749 ? 0 : 24;

      var slideWidth =
        (viewport.offsetWidth -
          ((perView - 1) * gap)) / perView;

      /*
        Current position.
      */

      var currentOffset =
        index * (slideWidth + gap);

      /*
        Follow the mouse/finger while dragging.
      */

      var newOffset =
        currentOffset - diff;

      /*
        Rubber-band at beginning/end.
      */

      var maxIndex = getMaxIndex();

      var maxOffset =
        maxIndex * (slideWidth + gap);

      if (newOffset < 0) {
        newOffset = newOffset * 0.3;
      }

      if (newOffset > maxOffset) {
        var excess =
          newOffset - maxOffset;

        newOffset =
          maxOffset + (excess * 0.3);
      }

      track.style.transform =
        'translate3d(-' +
        newOffset +
        'px, 0, 0)';
    }

    function endDrag() {
      if (!isDragging) return;

      isDragging = false;

      track.style.transition =
        'transform 300ms ease';

      var diff =
        currentX - startX;

      /*
        Swipe threshold.
      */

      var threshold = 40;

      if (Math.abs(diff) >= threshold) {

        /*
          Swipe LEFT = next ONE card.
        */

        if (diff < 0) {
          next();
        }

        /*
          Swipe RIGHT = previous ONE card.
        */

        else {
          prev();
        }

      } else {
        /*
          Didn't swipe enough.
          Return to current card.
        */

        update();
        resetAutoplay();
      }

      startX = 0;
      currentX = 0;
    }

    /* ================================
       TOUCH
    ================================= */

    viewport.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches.length) return;

        startDrag(
          e.touches[0].clientX
        );
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      function (e) {
        if (!isDragging) return;
        if (!e.touches.length) return;

        moveDrag(
          e.touches[0].clientX
        );
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      function () {
        endDrag();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchcancel',
      function () {
        endDrag();
      },
      { passive: true }
    );

    /* ================================
       DESKTOP MOUSE DRAG
    ================================= */

    viewport.addEventListener(
      'mousedown',
      function (e) {
        if (e.button !== 0) return;

        e.preventDefault();

        startDrag(e.clientX);
      }
    );

    document.addEventListener(
      'mousemove',
      function (e) {
        if (!isDragging) return;

        moveDrag(e.clientX);
      }
    );

    document.addEventListener(
      'mouseup',
      function () {
        if (!isDragging) return;

        endDrag();
      }
    );

    /* ================================
       PREVENT IMAGE DRAG
    ================================= */

    slides.forEach(function (slide) {
      var images =
        slide.querySelectorAll('img');

      images.forEach(function (img) {
        img.addEventListener(
          'dragstart',
          function (e) {
            e.preventDefault();
          }
        );
      });
    });

    /* ================================
       AUTOPLAY
    ================================= */

    function startAutoplay() {
      if (!autoplay) return;

      if (getMaxIndex() <= 0) return;

      stopAutoplay();

      autoplayTimer = setInterval(
        function () {
          next();
        },
        autoplaySpeed
      );
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    /* ================================
       HOVER
    ================================= */

    root.addEventListener(
      'mouseenter',
      function () {
        stopAutoplay();
      }
    );

    root.addEventListener(
      'mouseleave',
      function () {
        startAutoplay();
      }
    );

    /* ================================
       RESIZE
    ================================= */

    var resizeTimer;

    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(
          function () {
            perView = getPerView();

            /*
              Keep index within bounds.
            */

            var maxIndex =
              getMaxIndex();

            if (index > maxIndex) {
              index = maxIndex;
            }

            update();
            resetAutoplay();
          },
          150
        );
      }
    );

    /* ================================
       INITIALIZE
    ================================= */

    perView = getPerView();

    update();
    startAutoplay();
  }

  function initAll() {
    var sliders =
      document.querySelectorAll(
        '[data-reasons-slider]'
      );

    sliders.forEach(function (slider) {
      if (
        slider.dataset.sliderInitialized ===
        'true'
      ) {
        return;
      }

      slider.dataset.sliderInitialized = 'true';

      initSlider(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );
  } else {
    initAll();
  }

  /* Shopify Theme Editor */

  document.addEventListener(
    'shopify:section:load',
    function (e) {
      var slider =
        e.target.querySelector(
          '[data-reasons-slider]'
        );

      if (slider) {
        slider.dataset.sliderInitialized =
          'false';

        initAll();
      }
    }
  );
})();
